import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { TransactionClient } from "../../repsaApi";

const client = new TransactionClient(app_uri, axiosClient());

export default client;
